import { Chat } from "./chat-completion";
import { memoizePromise } from "./memoize-promise";
import { parentApi } from "./message-proxy";
declare global {
  interface Window {
    websim: {
      upload: (file: File) => Promise<string>;
      chat: Chat;
      imageGen: (args: {
        prompt: string;
        aspect_ratio?: string;
        width?: number;
        height?: number;
        seed?: number;
        transparent?: boolean;
      }) => Promise<{ url: string }>;
      textToSpeech: (args: {
        text: string;
        voice?: string;
        voice_sample?: string;
      }) => Promise<{ url: string }>;
      experimental?: {
        v0: {
          login: () => Promise<void>;
          /**
           * Saves the given htmlContent to a new websim site.
           * @param htmlContent html content to save
           * @returns object with id of the saved site
           */
          save(htmlContent: string): Promise<{ id: string }>;

          /**
           * Returns the HTML for the given siteId. Defaults to the current websimsite.
           * @param siteId
           * @returns HTML for the given siteId.
           */
          getHTML(siteId?: string): Promise<string>;
        };
      };
      getUser(): ReturnType<typeof parentApi.getUser>;
      /**@deprecated Use getBootstrap instead */
      getDistinctId(): ReturnType<typeof parentApi.getDistinctId>;
      getBootstrap(): ReturnType<typeof parentApi.getBootstrap>;
      getCreatedBy(): ReturnType<typeof parentApi.getCreatedBy>;
      getCreator(): ReturnType<typeof parentApi.getCreator>;
      getCurrentProject(): ReturnType<typeof parentApi.getCurrentProject>;
      getColorScheme(): ReturnType<typeof parentApi.getColorScheme>;
      // TODO: Remove this and replace it with direct calls to the API
      // now that we are able to make authenticated requests.
      internal_only_experimental: Record<string, never>;
    };
  }
}

export function initRuntime() {
  window.websim = Object.freeze({
    getUser: memoizePromise(parentApi.getUser),
    getDistinctId: memoizePromise(parentApi.getDistinctId),
    getBootstrap: memoizePromise(parentApi.getBootstrap),
    getCreatedBy: memoizePromise(parentApi.getCreatedBy),
    getCreator: memoizePromise(parentApi.getCreator),
    getCurrentProject: memoizePromise(parentApi.getCurrentProject),
    getColorScheme: parentApi.getColorScheme,
    upload: parentApi.uploadFile,
    chat: new Chat(),
    imageGen: parentApi.generateImage2,
    textToSpeech: (args: {
      text: string;
      voice?: string;
      voice_sample?: string;
    }) => {
      const body = {
        text: args.text,
        voice: args.voice,
        voice_sample: args.voice_sample,
      };
      if (args.voice_sample) {
        body.voice_sample = new URL(
          args.voice_sample,
          window.location.origin
        ).toString();
      }
      return parentApi.generateTextToSpeech(body);
    },
    experimental: Object.freeze({
      v0: Object.freeze({
        login: parentApi.login,
        save(): Promise<{ id: string }> {
          throw new Error("Feature not supported");
        },
        getHTML(): Promise<string> {
          throw new Error("Feature not supported");
        },
      }),
    }),
    internal_only_experimental: {},
  });
}
